

export default function ContactForm2({
    options,
    data 
}) {

    return (
        <div className="section-full p-t80 ">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            {/* Google Map Block */}
                            <div className="equal-col m-b30">
                                <div className="gmap-outline">
                                    <div className="google-map" style={{ width: '100%' }}>
                                        <iframe height={460} src={options?.map_url} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className=" bg-gray-light p-a30 radius-10 cons-contact-form-wrap">
                                <div className="section-head">
                                    <h2>Contact Form </h2>
                                    <div className="mt-separator-outer m-b30">
                                        <div className="mt-separator site-bg-primary" />
                                    </div>
                                </div>
                                <div className="mt-box">
                                    <form className="cons-contact-form contact-style-2" method="post" action="form-handler.php">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <input name="username" type="text" required className="form-control" placeholder="Name" />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <input name="email" type="text" className="form-control" required placeholder="Email" />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <textarea name="message" rows={6} className="form-control Message" required placeholder="Message" defaultValue={""} />
                                                </div>
                                            </div>
                                            <div className="col-md-12 text-right">
                                                <button name="submit" type="submit" value="Submit" className="site-button-secondry  m-r15">Submit</button>
                                                <button name="Resat" type="reset" value="Reset" className="site-button ">Reset </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}

